import { render, staticRenderFns } from "./TheTripBagIcon.vue?vue&type=template&id=5cd35660&"
import script from "./TheTripBagIcon.vue?vue&type=script&lang=js&"
export * from "./TheTripBagIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports